import { BaseService } from "../services/baseService";
import type { ServiceResponse } from "../services/baseService";
import { supabase } from "../lib/supabase/client";
import type { Company, Stats } from "../types/domain";
import { logger } from "../lib/logging/logger";

const base = new BaseService("companies");

export const companyRepository = {
  async findAllCompanies(): Promise<ServiceResponse<Company[]>> {
    logger.addBreadcrumb("company.findAll", { at: "repo" });
    const result = await base.findAll({
      columns: "id, name, cnpj, state, is_active, created_at",
      orderBy: { column: "name" },
    });
    if (!result.success) {
      logger.error("Erro ao buscar empresas", { error: result.error });
    }
    return result as ServiceResponse<Company[]>;
  },

  async updateCompanyStatus(
    companyId: string,
    isActive: boolean
  ): Promise<ServiceResponse<Company>> {
    logger.addBreadcrumb("company.updateStatus", {
      id: companyId,
      isActive,
    });
    const result = await base.update(companyId, {
      is_active: isActive,
      updated_at: new Date().toISOString(),
    } as any);
    if (!result.success) {
      logger.error("Erro ao atualizar status da empresa", {
        id: companyId,
        error: result.error,
      });
    }
    return result as ServiceResponse<Company>;
  },

  async getCompanyStats(): Promise<ServiceResponse<Stats>> {
    logger.addBreadcrumb("company.getStats", { at: "repo" });
    try {
      const { count: total, error: totalError } = await supabase
        .from("companies")
        .select("*", { count: "exact", head: true });
      if (totalError) throw totalError;

      const { count: active, error: activeError } = await supabase
        .from("companies")
        .select("*", { count: "exact", head: true })
        .eq("is_active", true);
      if (activeError) throw activeError;

      const stats: Stats = {
        total: total || 0,
        active: active || 0,
        inactive: (total || 0) - (active || 0),
      };

      return { success: true, data: stats };
    } catch (error: any) {
      logger.error("Erro ao obter estatísticas", { error });
      return {
        success: false,
        error: error?.message || "Erro desconhecido no banco de dados",
        originalError: error,
      } as ServiceResponse<Stats>;
    }
  },
};